import {
  MessageCircle, Inbox, AlertTriangle, CalendarX, CalendarClock, Baby, Hand,
  ClipboardCheck, AlertOctagon, LifeBuoy, MessageSquare, CheckCircle2, Clock, Receipt, Bell,
  type LucideIcon,
} from 'lucide-react';
import { NOTIFICATION_ICON } from './types';
import type { NotificationType } from './types';

/**
 * Registro EXPLÍCITO dos ícones de notificação.
 *
 * Antes daqui os dois componentes faziam `import * as Icons from 'lucide-react'`
 * e buscavam por string (`Icons[NOTIFICATION_ICON[tipo]]`). Busca dinâmica num
 * namespace inteiro **desliga o tree-shaking**: o bundler não tem como saber
 * qual ícone é usado, então embarca todos — foram **4.544 paths SVG** (~1.600
 * ícones) no chunk inicial, ~590 KB, para servir os 13 abaixo.
 *
 * Pior: `NotificationPopover` entra pelo `TopBar`, que carrega em TODA página,
 * então isso caía no chunk de entrada e ainda anulava o `lazy()` do router para
 * este módulo (o aviso `INEFFECTIVE_DYNAMIC_IMPORT` do build).
 *
 * ⚠ **Não voltar a indexar o namespace.** Ícone novo entra na lista de import
 * acima E no mapa — se faltar, cai no `Bell` (é o mesmo fallback de antes, não
 * quebra tela). O custo de esquecer é um ícone genérico; o custo de "resolver"
 * com `import *` são 500 KB no carregamento de todo mundo.
 */
const REGISTRY: Record<string, LucideIcon> = {
  MessageCircle, Inbox, AlertTriangle, CalendarX, CalendarClock, Baby, Hand,
  ClipboardCheck, AlertOctagon, LifeBuoy, MessageSquare, CheckCircle2, Clock, Receipt, Bell,
};

/** Ícone do tipo de notificação; `Bell` quando o tipo não tem ícone mapeado. */
export function notificationIcon(type: NotificationType): LucideIcon {
  return REGISTRY[NOTIFICATION_ICON[type]] ?? Bell;
}
